import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Form, Formik } from 'formik';
import React from 'react';
import { useDispatch } from 'react-redux';
import * as Yup from 'yup';
import BackArrow from '../../../components/BackArrow';
import Page from '../../../components/Page';
import PageHeader from '../../../components/PageHeader';
import WeekTimeRangeSelector from '../../../components/WeekTimeRangeSelector/WeekTimeRangeSelector';
import withVenue from '../../../hoc/withVenue';
import { useNotifications } from '../../../shared/contexts/Notifications/useNotifications';
import { getErrorMessage } from '../../../shared/utils/errors';
import { fetchVenue, updateVenue } from '../../../store/venues';

const useStyles = makeStyles(() => ({
  pageHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
  },
  openingHoursContainer: {
    '& .MuiDivider-root:last-of-type': {
      display: 'none',
    },
  },
  openingHoursDay: {
    padding: '8px 0',
    fontWeight: 'bold',
  },
  openingHours: {
    padding: '8px 0',
  },
}));

const OpeningSchema = Yup.object().shape({
  openings: Yup.array().of(Yup.string()).required('Please enter some opening hours'),
});

const OpeningHours = ({ venue, redirect }) => {
  const classes = useStyles();
  const { openings: openingTimes } = venue;
  const dispatch = useDispatch();
  const { showErrorNotification } = useNotifications();

  const handleOnSubmit = async (openings) => {
    try {
      await dispatch(updateVenue(openings));
      await dispatch(fetchVenue());
    } catch (error) {
      showErrorNotification(getErrorMessage(error));
      dispatch(fetchVenue());
    }
  };

  return (
    <Page>
      <PageHeader className={classes.pageHeader}>
        <Box>
          <BackArrow redirect={redirect} text="Settings" />
          <Typography variant="h2">Venue opening hours</Typography>
        </Box>
      </PageHeader>
      <Formik
        initialValues={openingTimes}
        validationSchema={OpeningSchema}
        onSubmit={handleOnSubmit}
      >
        {({ values, errors }) => (
          <Form>
            <WeekTimeRangeSelector
              onSubmit={(value) => {
                handleOnSubmit({ openings: value });
              }}
              label="Opening hours"
              name="openings"
              subjectText="Venue opening hours"
              validTimes={openingTimes}
              errors={errors}
              value={values.openings}
              showVenueOpeningHoursText
            />
          </Form>
        )}
      </Formik>
    </Page>
  );
};

export default withVenue(OpeningHours, '/settings/venue');
